import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { siteUrl } from '../content/seo';
export default function PageAnalytics() {
 const { pathname } = useLocation();
 useEffect(() => {
  // Preserve the existing GA property, without sending localhost or preview traffic.
  if (window.location.hostname !== new URL(siteUrl).hostname) return;
  if (!document.getElementById('analytics-loader')) {
   const script=document.createElement('script'); script.id='analytics-loader';script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id=G-K3T0K94HZ3';document.head.appendChild(script);
   window.dataLayer=window.dataLayer||[];
   window.gtag=function(){ window.dataLayer.push(arguments); };
   window.gtag('js',new Date());
  }
  window.gtag('config','G-K3T0K94HZ3',{page_path:pathname,page_title:document.title});
  if (pathname.startsWith('/resources')) window.gtag('event', 'resource_page_view', { resource_slug: pathname.split('/')[2] || 'hub' });
 },[pathname]);
 return null;
}
